import { useMemo } from "react";
import { useCustomerManagementStore } from "./store";
import { getTitleCaseSentence } from "_helpers";

export const useAuthUser = () => {
  const {
    customerManagement: { user },
  } = useCustomerManagementStore();

  const _user = useMemo(() => {
    let newUser = null;
    if (typeof user === "object") {
      newUser = { ...user };
      newUser.fullName = `${getTitleCaseSentence(
        newUser?.firstName
      )} ${getTitleCaseSentence(newUser?.lastName)}`;
    }
    return newUser;
  }, [user]);

  const isAuthenticated = useMemo(() => {
    let isAuthenticated = false;
    if (!!user) {
      isAuthenticated = true;
    }
    if (!!user && user?.isSignup === true) {
      isAuthenticated = false;
    }
    return isAuthenticated;
  }, [user]);

  return {
    isAuthenticated,
    user: _user,
  };
};
